import type { CSSProperties } from 'react';
import { neonVar } from '@/utils/neon-utils';

const fontFamily = neonVar('font-family', 'Roboto, Arial, Helvetica, sans-serif');
const textColor = 'var(--Text-Color-Dark, #333333)';

/** Wrapper clips width so row lines align with columns (same as configurations grade credit panel). */
export const gradeCreditRangesTableWrapperStyle: CSSProperties = {
  width: '600px',
  maxWidth: '100%',
  overflow: 'hidden',
};

export const gradeCreditRangesTableTableStyle: CSSProperties = {
  width: '600px',
  maxWidth: '100%',
  tableLayout: 'fixed',
  borderCollapse: 'collapse',
  fontFamily,
  fontSize: '14px',
  boxSizing: 'border-box',
};

export const gradeCreditRangesTableHeaderCellStyle: CSSProperties = {
  textAlign: 'left',
  padding: '12px 8px',
  borderBottom: '2px solid #E0E0E0',
  fontWeight: 600,
  color: textColor,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
};

export const gradeCreditRangesTableBodyCellStyle: CSSProperties = {
  padding: '8px',
  borderBottom: '1px solid #E0E0E0',
  verticalAlign: 'middle',
  boxSizing: 'border-box',
  overflow: 'hidden',
};

export const gradeCreditRangesTableGradeColStyle: CSSProperties = {
  width: '100px',
};

export const gradeCreditRangesTableCreditsColStyle: CSSProperties = {
  width: '250px',
};

export const gradeCreditRangesTableInputStyle: CSSProperties = {
  width: '240px',
  height: '32px',
  padding: '6px 12px',
  fontFamily,
  fontSize: '14px',
  border: '1px solid #BDBDBD',
  borderRadius: '4px',
  boxSizing: 'border-box',
};

export const gradeCreditRangesTableValidationSummaryStyle: CSSProperties = {
  fontFamily,
  fontSize: '14px',
  color: '#D32F2F',
  marginTop: '4px',
  marginBottom: 0,
};
